import styled from 'styled-components';
import SvgIcon from '../../SvgIcon';
import { getPx } from '../../helpers/common';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING } from '../../Input/constants';
import { ICON_SIZE } from '../../constants';
import { BACKGROUND_GRAY, INACTIVE_GRAY } from '../../colors';
import { height } from '../../style/height';
import { minWidth } from '../../style/min-width';
const FormIconRightWrapper = styled(SvgIcon)`
  outline: none;
  display: inline-flex;
  box-sizing: content-box;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;
  padding: 0;
  padding-right: ${getPx(INPUT_HORIZONTAL_PADDING)};
  border-radius: 4px;
  ${height(INPUT_HEIGHT)}
  ${minWidth(ICON_SIZE)}
  ${({
  disabled
}) => disabled ? `
        background-color: ${BACKGROUND_GRAY};
        color: ${INACTIVE_GRAY};
        cursor: default;
        pointer-events: all;
      ` : ''};
  svg {
    transition: transform 0.3s ease-in-out, fill 0.15s ease-out;
  }
  ${({
  $open
}) => $open ? `
        svg {
          transform: rotate(180deg);
        }
      ` : ''}
  ${({
  $multiline
}) => $multiline ? `
        position: absolute;
        bottom: 0;
        right: 0;
      ` : ''}
`;
export default FormIconRightWrapper;